var map = {
	"./ACL/acl.module": [
		"../../../../../src/app/ACL/acl.module.ts",
		"acl.module"
	],
	"./Analytics/analytics.module": [
		"../../../../../src/app/Analytics/analytics.module.ts",
		"analytics.module"
	],
	"./BOT/bot.module": [
		"../../../../../src/app/BOT/bot.module.ts",
		"bot.module"
	],
	"./Events/event.module": [
		"../../../../../src/app/Events/event.module.ts",
		"event.module"
	],
	"./Factura/factura.module": [
		"../../../../../src/app/Factura/factura.module.ts",
		"factura.module"
	],
	"./FeedBack/feedback.module": [
		"../../../../../src/app/FeedBack/feedback.module.ts",
		"feedback.module"
	],
	"./Loyalty/loyalty.module": [
		"../../../../../src/app/Loyalty/loyalty.module.ts",
		"loyalty.module",
		"common"
	],
	"./Marketing/marketing.module": [
		"../../../../../src/app/Marketing/marketing.module.ts",
		"marketing.module"
	],
	"./MeetingRoom/meeting.module": [
		"../../../../../src/app/MeetingRoom/meeting.module.ts",
		"meeting.module"
	],
	"./Monitoring/monitoring.module": [
		"../../../../../src/app/Monitoring/monitoring.module.ts",
		"monitoring.module"
	],
	"./OnlineOrdering/onlineorder.module": [
		"../../../../../src/app/OnlineOrdering/onlineorder.module.ts",
		"onlineorder.module",
		"common"
	],
	"./POS/pos.module": [
		"../../../../../src/app/POS/pos.module.ts",
		"pos.module",
		"common"
	],
	"./Restaurant_Details/restaurant.module": [
		"../../../../../src/app/Restaurant_Details/restaurant.module.ts",
		"restaurant.module"
	],
	"./Table_Reservation/table.module": [
		"../../../../../src/app/Table_Reservation/table.module.ts",
		"table.module"
	],
	"./kiosk/kiosk.module": [
		"../../../../../src/app/kiosk/kiosk.module.ts",
		"kiosk.module",
		"common"
	],
	"./master/master.module": [
		"../../../../../src/app/master/master.module.ts",
		"master.module"
	],
	"./payment/payment.module": [
		"../../../../../src/app/payment/payment.module.ts",
		"payment.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main